export const flyingEyeIdle = new Image();
flyingEyeIdle.src = "assets/characterSprites/flyingEye/Idle.png";
flyingEyeIdle.width = 1200/8;
flyingEyeIdle.height = 150/1;
flyingEyeIdle.yOffset = 10
flyingEyeIdle.xOffset = 150
flyingEyeIdle.cycleLoop = [0, 0, 1, 1, 2, 2, 3, 3];